module.exports = __webpack_public_path__ + "img/package-filter_aqs.945611c0.jpg";